import { render, staticRenderFns } from "./DiscountCompany.vue?vue&type=template&id=7ea36fca"
import script from "./DiscountCompany.vue?vue&type=script&lang=js"
export * from "./DiscountCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports